import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.901 5.5c-.11.412-.151.866-.151 1.375V11H6.875V8.25a2.76 2.76 0 0 1 2.75-2.75z",
      opacity: ".6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.75 26.125V11H6.875Q2.75 11 2.75 15.125v11q0 4.125 4.125 4.125h11q-4.125 0-4.125-4.125m-4.469-2.75c0 .564-.467 1.031-1.031 1.031a1.04 1.04 0 0 1-1.031-1.031v-5.5c0-.564.467-1.031 1.031-1.031s1.031.467 1.031 1.031z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.25 30.25h-1.375q-4.125 0-4.125-4.125V6.875q0-4.125 4.125-4.125h8.25q4.125 0 4.125 4.125v19.25q0 4.125-4.125 4.125H24.75",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24.75 24.75v5.5h-5.5v-5.5c0-.756.619-1.375 1.375-1.375h2.75c.756 0 1.375.619 1.375 1.375M19.25 18.906a1.04 1.04 0 0 1-1.031-1.031V11c0-.564.467-1.031 1.031-1.031s1.031.467 1.031 1.031v6.875c0 .564-.467 1.031-1.031 1.031M24.75 18.906a1.04 1.04 0 0 1-1.031-1.031V11c0-.564.467-1.031 1.031-1.031s1.031.467 1.031 1.031v6.875c0 .564-.467 1.031-1.031 1.031"
    }, null, -1)
  ])))
}
export default { render: render }